export default {};
throw new Error(`Could not resolve "gsap" imported by "@appletosolutions/reactbits". Is it installed?`)